"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateEndDate = exports.validateStartDate = exports.isBetweenMaxMin = exports.maximumDate = exports.minimumDate = void 0;
var date_fns_1 = require("date-fns");
var smartDate_1 = require("./smartDate");
exports.minimumDate = new Date(1899, 11, 31);
exports.maximumDate = new Date(2099, 11, 31);
var isBusinessAcceptableDate = function (date) {
    return date_fns_1.isAfter(date, exports.minimumDate);
};
var isAfterOrSameDay = function (date, dateToCompare) {
    return date_fns_1.isAfter(date, dateToCompare) || date_fns_1.isSameDay(date, dateToCompare);
};
var validMaxDate = function (date, maxDate) {
    if (maxDate) {
        return date_fns_1.isBefore(date, date_fns_1.addDays(maxDate, 1));
    }
    return true;
};
var validateMinDate = function (date, minDate) {
    if (minDate) {
        return date_fns_1.isAfter(date, date_fns_1.subDays(minDate, 1));
    }
    return true;
};
exports.isBetweenMaxMin = function (date, maxDate, minDate) {
    if (maxDate === void 0) { maxDate = exports.maximumDate; }
    if (minDate === void 0) { minDate = exports.minimumDate; }
    return validMaxDate(date, maxDate) && validateMinDate(date, minDate);
};
exports.validateStartDate = function (datePickerType, smartDateType, startDate, endDate, maxDate, minDate) {
    if (smartDateType) {
        return true;
    }
    if (startDate === undefined) {
        return false;
    }
    if (!isBusinessAcceptableDate(startDate)) {
        return false;
    }
    switch (datePickerType) {
        case smartDate_1.DatePickerTypeOptions.dateRange:
        case smartDate_1.DatePickerTypeOptions.simpleDateRange:
            return exports.isBetweenMaxMin(startDate, maxDate, minDate);
        case smartDate_1.DatePickerTypeOptions.firstAndLastOfMonth:
            return (date_fns_1.isFirstDayOfMonth(startDate) &&
                exports.isBetweenMaxMin(startDate, maxDate, minDate));
        default:
            return false;
    }
};
exports.validateEndDate = function (datePickerType, smartDateType, startDate, endDate, maxDate, minDate) {
    if (smartDateType) {
        return true;
    }
    if (!startDate || !endDate) {
        return false;
    }
    if (!isBusinessAcceptableDate(endDate)) {
        return false;
    }
    switch (datePickerType) {
        case smartDate_1.DatePickerTypeOptions.dateRange:
        case smartDate_1.DatePickerTypeOptions.simpleDateRange:
            return (isAfterOrSameDay(endDate, startDate) &&
                exports.isBetweenMaxMin(endDate, maxDate, minDate));
        case smartDate_1.DatePickerTypeOptions.firstAndLastOfMonth:
            return (isAfterOrSameDay(endDate, startDate) &&
                !date_fns_1.isAfter(endDate, date_fns_1.endOfMonth(smartDate_1.today)) &&
                date_fns_1.isLastDayOfMonth(endDate) &&
                exports.isBetweenMaxMin(endDate, maxDate, minDate));
        default:
            return false;
    }
};
